
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { JobDetailedData } from '@/models/jobDetailed';
import ProductsFieldset from '@/components/fieldsets/ProductsFieldset.vue';
import ServiceCodesFieldset from '@/components/fieldsets/ServiceCodesFieldset.vue';

@Component({
  components: {
    ProductsFieldset,
    ServiceCodesFieldset,
  },
})
export default class LegsFieldset extends Vue {
  @Prop(Object) public value: JobDetailedData;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  get detailedJob() {
    return this.value;
  }

  set detailedJob(value) {
    this.$emit('input', value);
  }
}
